export const TOAST_MESSAGES = {
  FAILED_FETCH_STOCK: "Failed to fetch Stock. Please try again.",
  FAILED_FETCH_PRODUCTS: "Failed to fetch Products. Please try again.",
  FAILED_FETCH_MRR: "Failed to fetch MRR. Please try again.",
  FAILED_FETCH_WAREHOUSE: "Failed to fetch Warehouse. Please try again.",
  FAILED_FETCH_SITE: "Failed to fetch sites. Please try again.",
  ERROR_FETCH_SITES: "Error fetching sites",
  SUCCESS_CREATE_STOCK: "Stock created successfully.",
  SUCCESS_UPDATE_STOCK: "Stock updated successfully.",
  SUCCESS_DELETE_STOCK: "Stock deleted successfully.",
  FAILED_CREATE_STOCK: "Failed to create Stock. Please try again.",
  FAILED_UPDATE_STOCK: "Failed to update Stock. Please try again.",
  FAILED_DELETE_STOCK: "Failed to delete Stock. Please try again.",
  FETCH_WAREHOUSE_FAILED: "Failed to fetch warehouses",
  FETCH_WAREHOUSE_ERROR: "Error fetching warehouses",
  ADD_WAREHOUSE_SUCCESS: "warehouse added successfully",
  ADD_WAREHOUSE_FAILED: "Failed to add warehouse",
  ADD_WAREHOUSE_ERROR: "Error adding warehouse",
  UPDATE_WAREHOUSE_SUCCESS: "warehouse updated successfully",
  UPDATE_WAREHOUSE_FAILED: "Failed to update warehouse",
  UPDATE_WAREHOUSE_ERROR: "Error updating warehouse",
  DELETE_WAREHOUSE_SUCCESS: "warehouse deleted successfully",
  DELETE_WAREHOUSE_FAILED: "Failed to delete warehouse",
  DELETE_WAREHOUSE_ERROR: "Error deleting warehouse",
  FETCH_RETURNNOTE_FAILED: "Failed to fetch return note.",
  CREATE_RETURNNOTE_FAILED: "Failed to Create return note.",
  CREATE_RETURNNOTE_SUCCESS: "Create return note successfully.",
  UPDATE_RETURNNOTE_SUCCESS: "Return note updated successfully",
  UPDATE_RETURNNOTE_FAILED: "Failed to update return note",
  DELETE_RETURNNOTE_SUCCESS: "Return note deleted successfully",
  DELETE_RETURNNOTE_FAILED: "Failed to delete return note",
  ERROR_FETCH_PRODUCTS: "Error fetching Products!",
  SUCCESS_CREATE_PRODUCT: "Product added successfully.",
  FAILED_CREATE_PRODUCT: "Failed to add product!",
  ERROR_CREATE_PRODUCT: "Error adding product",
  SUCCESS_UPDATE_PRODUCT: "Product updated successfully.",
  FAILED_UPDATE_PRODUCT: "Failed to update Product!",
  ERROR_UPDATE_PRODUCT: "Error updating Product!",
  SUCCESS_DELETE_PRODUCT: "Product deleted successfully.",
  FAILED_DELETE_PRODUCT: "Failed to delete Product!",
  ERROR_DELETE_PRODUCT: "Error deleting Product!",
  FAILED_FETCH_CATEGORY: "Failed to fetch categories",
  FETCH_DISPATCHNOTE_SUCCESS: "Failed to fetch dispatch note.",
  FETCH_DISPATCHNOTE_FAILED: "Failed to fetch dispatch note.",
  CREATE_DISPATCHNOTE_FAILED: "Failed to create dispatch note.",
  CREATE_DISPATCHNOTE_SUCCESS: "Create dispatch note successfully.",
  UPDATE_DISPATCHNOTE_SUCCESS: "Dispatch note updated successfully",
  UPDATE_DISPATCHNOTE_FAILED: "Failed to update dispatch note",
  DELETE_DISPATCHNOTE_SUCCESS: "Dispatch note deleted successfully",
  DELETE_DISPATCHNOTE_FAILED: "Failed to delete dispatch note",
  FAILED_FETCH_PRODUCT: "Failed to fetch product!",
  ERROR_FETCH_PRODUCT: "Error fetching product!",
  FAILED_FETCH_UOM: "Failed to fetch UOMs",
  ERROR_FETCH_UOM: "Error fetching UOMs",
  SUCCESS_CREATE_UOM:"UOM fetch successfully",
  SUCCESS_CREATE_CATEGORY: "Category Created Successfully",
  FAILED_CREATE_CATEGORY: "Failed to create category",
  ERROR_CREATE_CATEGORY: "Error creating category",
  SUCCESS_DELETE_CATEGORY: "Category deleted successfully",
  FAILED_DELETE_CATEGORY: "Failed to delete category",
  ERROR_DELETE_CATEGORY: "Error deleting category",
  FAILED_FETCH_MAKE: "Failed to fetch make",
  FAILED_CREATE_UOM: "Failed to create UOM",
  SUCCESS_DELETE_UOM: "UOM deleted successfully",
  FAILED_DELETE_UOM: "Failed to delete UOM",
  PRODUCTS_ADDED: "Products added successfully",
  PRODUCTS_FAILED_TO_ADD: "Some Products failed to add",
  FAILED_ADD_PRODUCT: "Failed to add products",
  ERROR_ADD_PRODUCT: "Error to add products",
  FAILED_FETCH_MATERIALS: "Failed to fetch available materials",
};

export const STOCK_LABELS = {
  product: "Product",
  UOM: "UOM",
  warehouse: "Warehouse",
  available_quantity: "Quantity",
};

export const STOCK_MODAL_MODES = {
  ADD: "Add",
  EDIT: "Edit",
  DELETE: "Delete",
  VIEW: "View",
};

export const DISPATCH_NOTE_COLUMNS = [
  "dn_code",
  "warehouse_name",
  "mrr_code",
  "status",
  "created_by",
  "created",
  "actions"
];

export const DISPATCH_NOTE_LABELS = {
  dn_code: "Code",
  warehouse_name: "Source Warehouse",
  mrr_code: "MRR Code",
  status: "Status",
  created_by: "Created By",
  created: "Created on",
  actions: "Actions"
};

export const DISPATCH_NOTE_STATUS_LABEL = {
  DRAFT: "Draft",
  PENDING_FOR_APPROVAL: "Pending for Approval",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  IN_TRANSIT: "In Transit",
  TRANSIT_COMPLETED: "Transit Completed",
  TRANSIT_FAILED: "Transit Failed"
};

export const DISPATCH_NOTE_STATUS = {
  DRAFT: "DRAFT",
  PENDING_FOR_APPROVAL: "PENDING_FOR_APPROVAL",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  IN_TRANSIT: "IN_TRANSIT",
  TRANSIT_COMPLETED: "TRANSIT_COMPLETED",
  TRANSIT_FAILED: "TRANSIT_FAILED",
};

export const STOCK_COLUMNS = [
  "warehouse",
  "product",
  "available_quantity",
  "UOM",
];

export const VALIDATION_MESSAGES = {
  NAME_REQUIRED: "Warehouse name is required",
  ADDRESS_REQUIRED: "Address is required",
  PERSON_IN_CHARGE_REQUIRED: "Person in charge is required"
}

export const TAB_OPTIONS = {
  WAREHOUSE: "Warehouse",
  SITES: "Sites"
};

export const WAREHOUSE_COLUMNS = [
  "name",
  "address",
  "person_in_charge",
  "actions",
];

export const WAREHOUSE_COLUMNS_LABELS = {
  name: "Name",
  address: "Address",
  person_in_charge: "Person in Charge",
  actions: "Actions",
};

export const WAREHOUSE_COLUMN_WIDTHS = {
  name: "w-44",
  address: "w-48",
  person_in_charge: "w-32",
  actions: "w-28",
};

export const SITES_COLUMNS = ["name", "project_name", "address", "actions"];

export const SITES_COLUMNS_LABELS = {
  name: "Site Name",
  project_name: "Project Name",
  address: "Address",
  actions: "Actions",
};

export const RETURN_NOTE_COLUMNS = [
  "warehouse_name",
  "rn_code",
  "status",
  "created",
  "created_by",
  "notes",
  "actions",
];

export const RETURN_NOTE_COLUMNS_LABELS = {
  rn_code: "RN code",
  warehouse_name: "Site",
  status: "Status",
  created: "Raised on",
  created_by: "Raised By",
  notes: "Notes",
  actions: "Actions",
};

export const STOCK_EXCHANGE_STATUS = {
  DRAFT: "Draft",
  PENDING_FOR_APPROVAL: "Pending FOR Approval",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  DISPATCH_IN_PROGRESS: "Dispatch in progress",
  COMPLETED: "Completed",
  READY_TO_DISPATCH: "Ready To dispatch",
  DISPATCHED: "Dispatched",
  IN_TRANSIT: "In Transit",
};

export const MATERIAL_COLUMN = [
  "product_name",
  "return_quantity",
  "comments",
  "actions"
]

export const MATERIAL_COLUMN_LABELS = {
  product_name: "Product",
  specification: "Specification",
  return_quantity: "Quantity",
  UOM: "UOM",
  comments: "Comments"
};

export const DISPATCH_NOTE_MATERIAL_COLUMN = [
  "product_name",
  "expected_quantity",
  "available_quantity",
  "dispatched_quantity",
  "note",
  "actions"
];

export const DISPATCH_NOTE_MATERIAL_LABEL = {
  product_name: "Product",
  expected_quantity: "Required Quantity",
  available_quantity: "Available Quantity",
  dispatched_quantity: "Dispatched Quantity",
  note: "Dispatch Note"
};

export const PRODUCTS_COLUMNS = [
  "SKU",
  "product_name",
  "specification",
  "make",
  "category_name",
  "UOM",
  "actions"
];

export const PRODUCTS_COLUMN_LABELS = {
  SKU: "SKU",
  product_name: "Product Name",
  specification: "Specification",
  make: "Brand",
  category_name: "Category",
  UOM: "UOM",
  actions: "Actions"
};

export const PRODUCT_COLUMN_WIDTHS = {
  product_name: "w-28",
  specification: "w-28",
  SKU: "w-12",
  UOM: "w-12",
  category_name: "w-16",
  actions: "w-28"
}

export const PRODUCT_EXCEL_COLUMNS = [
  { label: "Product Name", value: "product_name" },
  { label: "Specification", value: "specification" },
  { label: "SKU", value: "SKU" },
  { label: "UOM", value: "UOM" },
  { label: "Category", value: "category_name" },
]

export const RETURN_NOTE_STATUS = {
  DRAFT: "DRAFT",
  PENDING_FOR_APPROVAL: "PENDING_FOR_APPROVAL",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  RETURN_INITIATED: "RETURN_INITIATED", 
  RETURN_COMPLETED: "RETURN_COMPLETED", 
  RETURN_FAILED: "RETURN_FAILED", 
};

export const RETURN_NOTE_STATUS_LABELS = {
  DRAFT: "Draft",
  PENDING_FOR_APPROVAL: "Pending For Approval",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  RETURN_INITIATED: "Return Initiated", 
  RETURN_COMPLETED: "Return Completed", 
  RETURN_FAILED: "Return Failed", 
};

export const getRNStatusColor = (status) => {
  switch (status) {
    case RETURN_NOTE_STATUS.DRAFT:
      return "bg-gray-100 hover:bg-gray-150 transition-colors text-gray-700";
    case RETURN_NOTE_STATUS.PENDING_FOR_APPROVAL:
      return "bg-blue-50 text-blue-500 transition-colors";
    case RETURN_NOTE_STATUS.APPROVED:
      return "bg-green-50 text-green-500 transition-colors";
    case RETURN_NOTE_STATUS.REJECTED:
      return "bg-red-50 text-red-500";
    case RETURN_NOTE_STATUS.RETURN_INITIATED:
      return "bg-purple-50 text-purple-500";
    case RETURN_NOTE_STATUS.RETURN_COMPLETED:
      return "bg-blue-50 text-blue-500";
    case RETURN_NOTE_STATUS.RETURN_FAILED:
      return "bg-orange-50 text-orange-500";
    default:
      return "bg-white transition-colors text-black"; // fallback for unknown status
  }
};

export const getDNStatusColor = (status) => {
  switch (status) {
    case DISPATCH_NOTE_STATUS.DRAFT:
      return "bg-gray-100 hover:bg-gray-150 transition-colors text-gray-700";
    case DISPATCH_NOTE_STATUS.PENDING_FOR_APPROVAL:
      return "bg-yellow-50 text-yellow-500 transition-colors";
    case DISPATCH_NOTE_STATUS.APPROVED:
      return "bg-green-50 text-green-500 transition-colors";
    case DISPATCH_NOTE_STATUS.REJECTED:
      return "bg-red-50 text-red-500";
    case DISPATCH_NOTE_STATUS.IN_TRANSIT:
      return "bg-purple-50 text-purple-500";
    case DISPATCH_NOTE_STATUS.TRANSIT_COMPLETED:
      return "bg-blue-50 text-blue-500";
    case DISPATCH_NOTE_STATUS.TRANSIT_FAILED:
      return "bg-orange-50 text-orange-500";
    default:
      return "bg-white transition-colors text-black"; // fallback for unknown status
  }
};

export const RN_STATUS_OPTIONS = [
  {
    value: "",
    label: "All",
  },
  {
    value: RETURN_NOTE_STATUS.DRAFT,
    label: RETURN_NOTE_STATUS_LABELS.DRAFT,
  },
  {
    value: RETURN_NOTE_STATUS.PENDING_FOR_APPROVAL,
    label: RETURN_NOTE_STATUS_LABELS.PENDING_FOR_APPROVAL,
  },
  {
    value: RETURN_NOTE_STATUS.APPROVED,
    label: RETURN_NOTE_STATUS_LABELS.APPROVED,
  },
  {
    value: RETURN_NOTE_STATUS.REJECTED,
    label: RETURN_NOTE_STATUS_LABELS.REJECTED,
  },
  {
    value: RETURN_NOTE_STATUS.IN_TRANSIT,
    label: RETURN_NOTE_STATUS_LABELS.IN_TRANSIT,
  },
  {
    value: RETURN_NOTE_STATUS.COMPLETED,
    label: RETURN_NOTE_STATUS_LABELS.COMPLETED,
  },
];

export const PRODUCT_META_TABS = {
  CATEGORY: "category",
  UOM: "uom",
  ATTRIBUTE: "attribute",
};

export const CATEGORY_COLUMNS = [
  "category_name",
  "parent_category",
  "category_actions",
];

export const CATEGORY_COLUMN_LABELS = {
  category_name: "Category",
  parent_category: "Parent Category",
  category_actions: "Actions"
};

export const UOM_COLUMNS = [
  "uom_name",
  "uom_actions",
];

export const UOM_COLUMN_LABELS = {
  uom_name: "UOM",
  uom_actions: "Actions"
};

export const ATTRIBUTE_COLUMNS = [
  "attribute_name",
  "attribute_value",
  "attribute_actions",
];

export const ATTRIBUTE_COLUMN_LABELS = {
  attribute_name: "Attribute",
  attribute_value: "Value",
  attribute_actions: "Actions"
};